const ViewDevspecfundsSmentserviceplatform = () => import('../modules/xmsb/energy/operators/ViewDevspecfundsSmentserviceplatformGzl')

export default [
  {

    path: '/devspecfundssmentserviceplatformview',
    name: 'devspecfundssmentserviceplatformview',
    component: ViewDevspecfundsSmentserviceplatform,
    meta: {
      title: '发展专项资金项-中小企业服务平台建设项目',
      fullscreen: true,

    },
  },
]
